import { Injectable } from '@angular/core';
import { TableFilterObject } from '../models';

interface IndexesForPage {
  startIndex: number;
  endIndex: number;
}

@Injectable()
export class TableDataService {

  constructor() {
  }

  getItemsForPage<T>(allItems: Array<T>, currentPageNum: number, pageSize: number): Array<T> {
    const pageIndices = this.getIndexesForPage(allItems.length, currentPageNum, pageSize);
    return allItems.slice(pageIndices.startIndex, pageIndices.endIndex + 1);
  }

  private getIndexesForPage(totalItemsNum: number, currentPageNum: number, pageSize: number): IndexesForPage {
    let startIndex: number = (currentPageNum - 1) * pageSize;
    let endIndex: number = Math.min(startIndex + pageSize - 1, totalItemsNum - 1);
    return {
      startIndex,
      endIndex
    };
  }

  sortItems<T>(itemsToSort: Array<T>, isAscendingOrder: boolean, sortByKey: string): Array<T> {
    return itemsToSort.sort(function (first, second) {
      const codeA = typeof first[sortByKey] === 'string' ? first[sortByKey].toLowerCase() : first[sortByKey];
      const codeB = typeof second[sortByKey] === 'string' ? second[sortByKey].toLowerCase() : second[sortByKey];
      const reverse = isAscendingOrder ? 1 : -1;
      if (codeA < codeB) {
        return -1 * reverse;
      }
      if (codeA > codeB) {
        return 1 * reverse;
      }
      return 0;
    });
  }

  filterItems<T>(itemsToFilter: Array<T>, filtersToApply: TableFilterObject): Array<T> {
    return itemsToFilter.filter(item => {
      for (let filterKey in filtersToApply) {
        if (typeof item[filterKey] === 'undefined' || (filtersToApply[filterKey] !== null && item[filterKey] !== filtersToApply[filterKey])) {
          return false;
        }
      }
      return true;
    });
  }
}
